





























































































































































































import { defineComponent, reactive, Ref } from '@vue/composition-api'

import { IUser, UserRole } from '@/types/user'
import { MatchedState, UserState } from '@/types/store'

import { suggestBrandSkus } from '@/api/brand-skus'

import useVuex from '@/utils/useVuex'
import { autoCompleteFilter } from '@/utils/kanaToHira'

import Layout from '@/components/organisms/common/Layout.vue'
import { MatchedsTable } from '@/components/organisms/re-matcheds'
import { MasterAutocomplete } from '@/components/atoms'
import { IRecommend } from '@/types/recommend'
import { IMatched } from '@/types/matched'

type Props = {}

export default defineComponent({
  name: 'ReMatcheds',
  components: { Layout, MatchedsTable, MasterAutocomplete },
  setup(props: Props, context) {
    const store = context.root.$store
    const state = reactive<{
      matcheds: Ref<IMatched[]>
      total: Ref<number>
      isMatchedsLoading: Ref<boolean>
      user: Ref<IUser | null>
      isCreatedAtStartOpen: boolean
      isCreatedAtEndOpen: boolean
      createdAtStart: string | null
      createdAtEnd: string | null
      code: string
      name: string
      targetName: string
      isTargetNamePerfectMatch: boolean
      targetOcr: string
      isTargetOcrPerfectMatch: boolean
      categoryId: number | null
      isToBeDeleted: boolean
      isApproved: boolean
      list: IRecommend[]
      searchInput: string
      suggestName: string
    }>({
      matcheds: useVuex<MatchedState['matcheds']>(
        context,
        () => store.getters['matched/matcheds'],
      ),
      total: useVuex<MatchedState['total']>(
        context,
        () => store.getters['matched/total'],
      ),
      isMatchedsLoading: useVuex<MatchedState['isMatchedsLoading']>(
        context,
        () => store.getters['matched/isMatchedsLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      isCreatedAtStartOpen: false,
      isCreatedAtEndOpen: false,
      createdAtStart: null,
      createdAtEnd: null,
      code: '',
      name: '',
      targetName: '',
      isTargetNamePerfectMatch: false,
      targetOcr: '',
      isTargetOcrPerfectMatch: false,
      categoryId: null,
      isToBeDeleted: false,
      isApproved: false,
      list: [],
      searchInput: '',
      suggestName: '',
    })

    const execRecommendSearch = async (q: string) => {
      state.list = await suggestBrandSkus(q)
    }

    const onSelect = (recommend?: IRecommend) => {
      if (recommend !== undefined) {
        state.code = recommend.code
      }
    }

    const onKeyDown = async (e: any) => {
      if (e.code === 'Enter' && e.key === 'Enter') {
        return
      }
      if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
        return
      }
      if (e.isComposing === true && e.code !== 'Enter') {
        return
      }
      if (e.target.value.length === 0) {
        return
      }
      execRecommendSearch(e.target.value)
    }

    const onUpdateSearchInput = (searchInput: string | null) => {
      if (searchInput !== null) {
        state.searchInput = searchInput
      }
    }

    const categories = [
      {
        text: '生鮮・惣菜',
        value: 1,
      },
      {
        text: '飲食チェーン',
        value: 2,
      },
      {
        text: 'その他商品',
        value: 3,
      },
      {
        text: 'PBその他商品',
        value: 10,
      },
    ]

    const search = async () => {
      try {
        await store.dispatch('matched/getMatcheds', {
          createdAtStart: state.createdAtStart || '',
          createdAtEnd: state.createdAtEnd || '',
          code: state.code,
          targetName: state.targetName,
          isTargetNamePerfectMatch: state.isTargetNamePerfectMatch,
          targetOcr: state.targetOcr,
          isTargetOcrPerfectMatch: state.isTargetOcrPerfectMatch,
          categoryId: state.categoryId || -1,
          isToBeDeleted: state.isToBeDeleted,
          isApproved: state.isApproved,
          suggestName: state.suggestName,
        })
      } catch (_) {
        store.dispatch('matched/reset')
        alert('タイムアウトしました。検索条件を変更して再度お試しください。')
      }
    }

    return {
      state,
      search,
      onSelect,
      onKeyDown,
      onUpdateSearchInput,
      autoCompleteFilter,
      UserRole,
      categories,
    }
  },
})
